// helpers/ghsx.js

import axios from "axios";

/* ======================================================
   GET GHSX RATE OPTIONS
   - Fixed: 1 GHSX = 1 GHS
   - Configured: rate and minimum from backend
====================================================== */

export const fetchGhsxRate = async () => {
  try {
    const res = await axios.get("/api/ghsx/rate", {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   BUY GHSX
   pricingOption:
   - "fixed"
   - "configured"
====================================================== */

export const buyGHSX = async ({
  amount,
  pricingOption = "fixed",
  paymentMethod = "usdt",
  currency = "USD",
}) => {
  const payload = {
    amount,
    pricingOption,
    paymentMethod,
    currency,
  };

  console.log("[BUY_GHSX API] payload", payload);

  try {
    const res = await axios.post(
      "/api/ghsx/buy-ghsx",
      payload,
      {
        withCredentials: true,
      }
    );

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   GET GHSX HISTORY
====================================================== */

export const fetchGhsxHistory = async () => {
  try {
    const res = await axios.get("/api/ghsx/history", {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};